module.exports = __webpack_public_path__ + "img/empty-interest-management.f3204f07.svg";